{<template>
	<v-card class="chat-popup" :class="{'bubble-active': active}">
		<div @click="setActive()" v-click-outside="onClickOutside" class="chat-popup-activator">
			<v-card-title class="d-flex flex-row w-100 align-items-center px-5" style="height: 60px">
				<div v-if="beginChat" class="d-flex flex-row align-items-center">
					<v-tooltip v-if="beginChat" bottom :open-delay="500">
						<template v-slot:activator="{ on }">
							<v-btn
								v-on="on"
								@click="chat ? minimizePopup() : close()"
								plain
								icon
								width="20"
								class="mr-2"
								:color="active ? 'white' : 'black'"
							>
								<v-icon>mdi-chevron-left</v-icon>
							</v-btn>
						</template>
						{{ $vuetify.lang.t('$vuetify.views.chat.returnToList') }}
					</v-tooltip>
					{{ title }}
				</div>
				<div v-else class="d-flex flex-row align-items-center w-100">
					<div v-if="chat" class="overflow-dots flex-fill">{{ chatName }}</div>
					<div class="ml-auto d-flex flex-row align-items-center">
						<v-menu
							v-if="!beginChat && !chat.is_direct && !chat.is_public"
							bottom
							offset-y
							left
						>
							<template v-slot:activator="{ on }">
								<v-btn
									v-on="on"
									icon
									small
									right
									text
									:color="active ? 'white' : 'black'"
									>
									<v-icon>mdi-dots-vertical</v-icon>
								</v-btn>
							</template>
							<v-list>
								<v-list-item @click="$refs.attachUser.showDialog()">{{ $vuetify.lang.t('$vuetify.views.chat.addUsers') }}</v-list-item>
								<v-list-item @click="$refs.usersList.showDialog()">{{ $vuetify.lang.t('$vuetify.views.chat.usersList') }}</v-list-item>
							</v-list>
						</v-menu>
						<v-tooltip v-if="!beginChat" bottom :open-delay="500">
							<template v-slot:activator="{ on }">
								<v-btn
									v-if="bubble"
									:to="chat && chat.hash ? {name: 'Chat', params: {hash: chat.hash}} : null"
									v-on="on"
									icon
									dense
									:color="active ? 'white' : 'black'"
								>
									<v-icon>$external-link</v-icon>
								</v-btn>
							</template>
							{{ $vuetify.lang.t('$vuetify.views.chat.expand') }}
						</v-tooltip>
						<v-tooltip v-if="!beginChat && bubble" bottom :open-delay="500">
							<template v-slot:activator="{ on }">
								<v-btn
									v-on="on"
									@click="chat ? minimizePopup() : close()"
									icon
									dense
									:color="active ? 'white' : 'black'"
								>
									<v-icon>mdi-chevron-down</v-icon>
								</v-btn>
							</template>
							{{ $vuetify.lang.t('$vuetify.views.chat.minimize') }}
						</v-tooltip>
					</div>
				</div>
			</v-card-title>
			<v-divider />
			<v-card-text v-if="beginChat" class="pa-3 relative" :style="'overflow-y: auto; max-height: ' + baseHeight + '; height: ' + baseHeight + 'px'">
				<v-overlay
					v-if="loadings.attachments || loadings.sending || loadings.creatingRoom || loadings.gettingRoom"
					:value="true"
					absolute
					:dark="false"
					light
					color="white"
					opacity="1"
				>
					<v-progress-circular
						indeterminate
						size="30"
					></v-progress-circular>
				</v-overlay>
				<div class="d-flex flex-wrap align-items-center w-100 mb-3">
					<v-btn-toggle
						v-model="fields.isDirect"
						@change="setDirect()"
						mandatory>
						<v-tooltip top>
							<template v-slot:activator="{ on }">
								<v-btn
									v-on="on"
									:value="true"
									color="white"
									small>
									<v-icon size="18">mdi-account-outline</v-icon>
								</v-btn>
							</template>
							{{ $vuetify.lang.t('$vuetify.views.chat.room.roomDirect') }}
						</v-tooltip>
						<v-tooltip top>
							<template v-slot:activator="{ on }">
								<v-btn
									v-on="on"
									:value="false"
									color="white"
									small>
									<v-icon size="20">mdi-account-group-outline</v-icon>
								</v-btn>
							</template>
							{{ $vuetify.lang.t('$vuetify.views.chat.room.chatGroup') }}
						</v-tooltip>
					</v-btn-toggle>
					<div class="ml-auto">
						<v-menu
							v-if="!fields.isDirect"
							v-model="showTab"
							bottom
							offset-y
							:close-on-content-click="false"
						>
							<template v-slot:activator="{ on }">
								<v-btn
									v-on="on"
									depressed
									text
									small
									class="white"
									>
									<template v-if="tab =='private'">
										<v-icon small class="mr-1">mdi-lock-outline</v-icon>{{ $vuetify.lang.t('$vuetify.views.chat.room.private') }}
									</template>
									<template v-else><v-icon small class="mr-1">mdi-web</v-icon>{{ $vuetify.lang.t('$vuetify.views.chat.room.public') }}</template>
									<v-icon>mdi-chevron-down</v-icon>
								</v-btn>
							</template>
							<v-list>
								<v-list-item
									@click="setTab('private')"
									:class="{active: tab == 'private'}"
									class="link">
									{{ $vuetify.lang.t('$vuetify.views.chat.room.private') }}
								</v-list-item>
								<v-list-item
									@click="setTab('public')"
									:class="{active: tab == 'public'}"
									class="link">
									{{ $vuetify.lang.t('$vuetify.views.chat.room.public') }}
								</v-list-item>
							</v-list>
						</v-menu>
					</div>
				</div>
				<div v-if="!fields.isDirect && fields.isPublic">
					<v-text-field
						v-model="fields.name"
						:rules="[rules.required]"
						outlined
						dense
						hide-details="auto"
						placeholder="Nazwa czatu"
						class="mb-1"
						/>
				</div>
				<div v-if="(fields.isDirect && !fields.users.length) || !fields.isDirect">
					<search-user
						v-if="!fields.isPublic"
						@selected="setUser"
						all
						:placeholder="fields.isDirect ? null : $vuetify.lang.t('$vuetify.views.chat.searchMultipleUsers')"
						:max-height="300"
						/>
				</div>
				<div v-if="fields.isDirect && fields.users.length == 1" class="d-flex flex-column align-items-center">
					<div>
						<avatar :user="fields.users[0]"/>
					</div>
					<div class="mx-auto text-center mt-2">
						<div class="bold font-14">
							{{ fields.users[0].name }}
						</div>
						{{ fields.users[0].job_position }}
					</div>
				</div>
				<v-list v-else-if="!fields.isDirect && fields.users.length" >
					<v-list-item v-for="user in fields.users" :key="user.id" class="px-0">
						<avatar :user="user" class="mr-2"/> <span class="bold">{{ user.name }}</span>
						<div class="ml-auto">
							<v-btn icon @click="removeUser(user)"><v-icon>mdi-close</v-icon></v-btn>
						</div>
					</v-list-item>
				</v-list>
			</v-card-text>
			<v-card-text v-if="chat && !beginChat" class="pa-0 relative" :style="'height: ' + baseHeight + 'px'">
				<div class="chat-messages-content" @scroll="onScroll" ref="messages-content" :style="'max-height:' + contentHeight + '; min-height: ' + contentHeight">
					<div v-show="chat && chat.messages && chat.messages.meta && chat.messages.meta.current_page < chat.messages.meta.last_page" ref="more-loaders">
						<v-skeleton-loader
							v-if="initiated"
							type="list-item-two-line"
						></v-skeleton-loader>
						<div v-if="showIntersector" v-intersect="infiniteScrolling" class="intersector" />
					</div>
					<div v-if="loadings.loading">
						<div v-for="i in 5" :key="i">
							<v-skeleton-loader
								:type="i%2 == 0 ? 'list-item-avatar-three-line' : 'list-item-two-line' "
							></v-skeleton-loader>
						</div>
					</div>
					<messages-list
						v-else
						:key="globalKey"
						:messages="sortedMessages"
						:is-public="chat.is_public"
						:is-direct="chat.is_direct"
						@intersected="messageIntersected"
						:users="chat.users"
						@previewImage="previewImage"
						@deleteImage="deleteImage"
						@deleteAttachment="deleteAttachment"
						/>
					<div v-if="!loadings.sending && !loadings.loading && !sortedMessages.length" class="text-center">
						<v-icon class="muted" size="32">mdi-message-outline</v-icon>

							{{ $vuetify.lang.t('$vuetify.views.chat.messages.addFirstMessage') }}
					</div>
					<v-skeleton-loader
						v-if="loadings.sending"
						type="list-item-two-line"
					></v-skeleton-loader>
					<div v-if="showMorePopup" @click="showMorePopup = false, scroll()" class="absolute" :style="showMoreStyle">
						<v-btn>{{ $vuetify.lang.t('$vuetify.views.chat.messages.newMessages') }}</v-btn>
					</div>
					<div ref="end" :class="{'mb-10': fields.images.length}" />
				</div>

			</v-card-text>

			<v-card-actions class="relative px-0" >
				<v-sheet
					v-show="fields.images.length"
					:max-width="baseWidth"
					:min-width="baseWidth"
					class="absolute chat-images-wrapper"
					ref="imagesWrapper"
					:style="imagesWrapperStyle"  >
					<v-overlay
						v-if="fields.images.length && (loadings.images || loadings.sending)"
						:value="true"
						absolute
						:dark="false"
						light
						color="white"
						opacity="0.8"
					>
						<v-progress-circular
							indeterminate
							size="30"
						></v-progress-circular>
					</v-overlay>

					<v-slide-group
						multiple
						show-arrows
					>
						<v-slide-item
							v-for="(image, index) in fields.images"
							:key="index"
							style="width: 90px"
						>
							<div class="relative mt-3">
								<v-btn @click="removeImage(index)" class="remove" icon outlined x-small><v-icon>mdi-close</v-icon></v-btn>
								<v-img :src="image.data" max-width="80" max-height="80" class="rounded" />
							</div>
						</v-slide-item>
					</v-slide-group>
				</v-sheet>

				<v-sheet
					v-show="fields.attachments.length"
					:max-width="baseWidth"
					:min-width="baseWidth"
					class="absolute chat-images-wrapper pt-1"
					ref="attachmentsWrapper"
					:style="attachmentsWrapperStyle"  >
					<v-overlay
						v-if="fields.attachments.length && (loadings.attachments || loadings.sending)"
						:value="true"
						absolute
						:dark="false"
						light
						color="white"
						opacity="0.8"
					>
						<v-progress-circular
							indeterminate
							size="30"
						></v-progress-circular>
					</v-overlay>

					<v-slide-group
						multiple
						show-arrows
					>
						<v-slide-item
							v-for="(attachment, index) in fields.attachments"
							:key="index"
							class="pa-1"
						>
							<v-chip class="px-2 mx-1" small>
								{{ trimmed(attachment.name) }}
								<v-btn @click="removeAttachment(index)" icon x-small><v-icon>mdi-close</v-icon></v-btn>
							</v-chip>
						</v-slide-item>
					</v-slide-group>
				</v-sheet>
				<v-slide-x-transition>
					<div v-if="chat && currentWhisperingUsers.length"
						class="whispering"
					>
							<div class="d-flex flex-row align-items-center">
								<div class="jumping-dots mr-1">
									<span class="dots-cont">
										<span class="dot dot-1"></span>
										<span class="dot dot-2"></span>
										<span class="dot dot-3"></span>
									</span>
								</div>
								<div class="overflow-dots" style="max-width: 300px">{{ whisperersName }}...</div>
							</div>
					</div>
				</v-slide-x-transition>
				<div class="content-wrapper w-100 px-2" :class="{disabled: loadings.sending || loadings.creatingRoom}">

					<div ref="wid" class="w-100"></div>
					<div v-if="beginChat && !fields.isPublic && !loadings.sending && !loadings.creatingRoom && !loadings.gettingRoom">
						<div v-if="fields.isDirect && !fields.users.length" class="chat-users-tip">
							<v-icon small class="mr-1">mdi-information-outline</v-icon> Dodaj użytkownika
						</div>
						<div v-else-if="!fields.isDirect && !fields.isPublic && !fields.users.length" class="chat-users-tip">
								<v-icon small class="mr-1">mdi-information-outline</v-icon> Dodaj co najmniej 2 użytkowników
						</div>
						<div v-else-if="!fields.isDirect && fields.users.length == 1" class="chat-users-tip">
							Dodaj jeszcze 1 użytkownika
						</div>
					</div>
					<div v-if="chatExists && !loadings.sending && !loadings.creatingRoom && !loadings.gettingRoom" class="text-center">
						<div class="chat-users-tip">
							<v-icon small class="mr-1">mdi-information-outline</v-icon> Taki czat istnieje
						</div>
					</div>
					<content-editable-input
						v-else-if="send && showInput"
						@input="onInput"
						@enterPress="handleMessage"
						@addImage="$refs.attachImage.showDialog()"
						@addAttachments="$refs.attachAttachments.showDialog()"
						v-model="fields.content"
						:chat-room-users="!beginChat && chat && chat.users && !chat.is_public ? chat.users : null"
						:contentKey="inputKey"
						emojis
						images
						attachments
						:disabled="beginChat && (loadings.sending || loadings.creatingRoom)"
						:error="validated && errors.content ? true : false"
						ref="content-editable-input"
						:placeholder="$vuetify.lang.t('$vuetify.views.chat.messages.startTyping')"
						:class="[{ 'post-comment-add-input--dark' : dark }, 'post-comment-add-input d-flex flex-grow-1 font-14 rounded px-2  w-100']"
					/>
				</div>
			</v-card-actions>
			<v-card-actions class="relative">
				<v-btn
					v-if="beginChat && chatExists"
					:disabled="loadings.sending || loadings.creatingRoom || loadings.gettingRoom"
					@click="goToChat(chatExists)"
					color="primary"
					block>Przejdź <v-icon>mdi-chevron-right</v-icon></v-btn>
				<v-btn
					v-else-if="!chatExists && !send"
					@click="handleMessage()"
					:disabled="!fields.name || loadings.sending || loadings.creatingRoom || loadings.gettingRoom"
					color="primary"
					block>
					Utwórz pokój
				</v-btn>
				<v-btn
					v-else
					@click="handleMessage()"
					:disabled="(!fields.content.content && !fields.images.length && !fields.attachments.length) || (!chat && loadings.sending) || loadings.creatingRoom"
					:loading="(!chat && loadings.sending) || loadings.creatingRoom"
					color="primary"
					block
					ref="send"
				>
					Wyślij
				</v-btn>
			</v-card-actions>
		</div>
		<attach-image-dialog ref="attachImage" @selected="setImage" :key="imageKey"/>
		<attach-attachments-dialog ref="attachAttachments" @selected="addAttachments" :key="'attachments-' + attachmentsKey"/>
		<delete-image-dialog ref="deleteImage" />
		<delete-attachment-dialog ref="deleteAttachment" />
		<image-preview-dialog ref="previewImage" />
		<attach-user-dialog v-if="!beginChat && chat" ref="attachUser" :chat="chat" @added="refresh()" />
		<chat-users-dialog v-if="!beginChat && chat" ref="usersList" :chat="chat" />
	</v-card>
</template>

<script>
import ContentEditableInput from "@/components/items/ContentEditableInput";
import {mapGetters} from 'vuex';
import SearchUser from "@/components/search/SearchUser";
import Avatar from '@/components/Avatar';
import MessagesList from '@/components/chat/messenger/partials/MessagesList';
import _ from 'lodash';
import AttachImageDialog from '@/components/wall/dialogs/AttachImageDialog';
import ImagePreviewDialog from '@/components/items/dialogs/ImagePreviewDialog';
import DeleteImageDialog from '@/components/chat/dialogs/DeleteImageDialog';
import AttachAttachmentsDialog from "@/components/wall/dialogs/AttachAttachmentsDialog";
import DeleteAttachmentDialog from '@/components/chat/dialogs/DeleteAttachmentDialog';
import {getChatName} from '@/functions/chat';
import AttachUserDialog from '@/components/chat/dialogs/AttachUserDialog';
import ChatUsersDialog from '@/components/chat/dialogs/ChatUsersDialog';
export default {
	props: {
		chat: {
			required: false,
			type: Object
		},
		beginChat: {
			type: Boolean,
			default: false
		},
		baseHeight: {
			type: Number,
			default: 400
		},
		bubble: {
			type: Boolean,
			default: false
		}
	},
	components: {
		ContentEditableInput,
		SearchUser,
		Avatar,
		MessagesList,
		AttachImageDialog,
		ImagePreviewDialog,
		DeleteImageDialog,
		AttachAttachmentsDialog,
		DeleteAttachmentDialog,
		AttachUserDialog,
		ChatUsersDialog
	},
	data() {
		return {
			active: false,
			fields: {
				name: '',
				users: [],
				isDirect: true,
				isPublic: false,
				content: '',
				images: [],
				imageTokens: [],
				attachments: [],
				attachmentTokens: []
			},
			send: true, // If room is public, we may want only to create room, without sending message
			inputKey: 0,
			imageKey: 0,
			validated: false,
			errors: {

			},
			loadings: {
				loading: false,
				sending: false,
				more: false,
				image: false,
				images: false,
				attachments: false,
				creatingRoom: false,
				gettingRoom: false
			},
			contentHeight: this.baseHeight,
			initiated: false,
			intersecting: false,
			lastScrollTop: 0,
			scrolledUp: false,
			lastMessage: null,
			showMoreStyle: 'bottom: 40px; right: 10px',
			showMorePopup: false,
			seenMessages: [],
			scrolling: false,
			imagesWrapperStyle: 'bottom: 98px; left: 10px',
			attachmentsWrapperStyle: 'bottom: 98px; left: 10px',
			attachmentsKey: 0,
			baseWidth: 360,
			showTab: false,
			rules: {
				required: value => !!value || this.$vuetify.lang.t('$vuetify.validation.required')
			},
			existsKey: 0,
			newChat: null,
			globalKey: 0,
			usersWhispering: [],
			currentWhisperTimeout: 0
		}
	},
	watch: {
		tab: function(newVal) {
			if(this.beginChat) {
				if(newVal == 'public') {
					this.fields.name = '';
					this.fields.isPublic = true;
					this.fields.isDirect = false;
					this.fields.users = [];
					this.send = false;
				}
				else {
					this.fields.isPublic = false;
					this.send = true;
					this.fields.name = '';
				}
			}
		},
		'$vuetify.breakpoint.height': function() {
			this.setBaseWidth();
		},
		'$vuetify.breakpoint.width': function() {
			this.setBaseWidth();
		},
		beginChat: function(newVal, oldVal) {
			console.log("BEGIN CHAT CHANGE", newVal, oldVal)
			if(oldVal && !newVal) {
				this.globalKey++;
			}
		},
		chat: {
			handler(newVal, oldVal) {
				if(newVal.bubble_active) {
					this.active = true;
				}
				else {
					this.active = false;
				}

				if((!oldVal && !oldVal.bubble && newVal.bubble) || (!oldVal.bubble_expanded && newVal.bubble_expanded)) {
					this.setInitiated();
				}
				if(this.lastMessage && this.sortedMessages.length && (this.lastMessage.id != this.sortedMessages[this.sortedMessages.length - 1].id)) {
					setTimeout(() => {
						if(this.$refs['messages-content'].scrollTop > this.$refs['messages-content'].scrollHeight - 700) {
							this.scroll();
						}
						else {
							this.showMorePopup = true;
						}
					}, 300)
				}
				this.setLastMessage();
			},
			deep: true
		}
	},
	computed: {
		...mapGetters({
			activeBubble: 'chat/activeBubble',
			rooms: 'chat/rooms',
			user: 'auth/user',
			visible: 'application/visible',
			tab: 'chat/tab',
			clock: 'application/clock',
			whisperingUsers: 'chat/whisperingUsers',
			whisperTimeout: 'chat/whisperTimeout'
		}),
		currentWhisperingUsers() {
			if(this.chat) {
				let users = this.whisperingUsers.filter(x => x.where == 'chat' && x.chat_room_id == this.chat.id && this.clock - x.clock <= this.whisperTimeout).map((item) => {
					return item.user?.name;
				});
				return users;
			}
			return [];
		},
		whisperersName() {
			if(this.chat) {
				let name = '';
				if(this.currentWhisperingUsers.length) {
					if(this.currentWhisperingUsers.length <= 2) {
						name = this.currentWhisperingUsers.join(", ") + ' ' + this.$vuetify.lang.t('$vuetify.views.chat.isTyping');
					}
					else {
						name = this.currentWhisperingUsers.length +' ' + this.$vuetify.lang.t('$vuetify.views.chat.usersTyping');
					}

				}
				return name;
			}
			return null;

		},
		chatExists() {
			// Check if chat room exists with current users in fields.users array
			let ids = this.fields.users.map(function(user) { return user.id; });
			ids.push(this.user.id);
			let existingRoom = null;
			this.rooms.forEach(room => {
				if(room.is_public) {
					if(this.fields.name == room.name) {
						existingRoom = room;
					}
				}
				else {
					if((this.fields.isPublic == room.is_public) && (this.fields.isDirect == room.is_direct)) {
						if(room.users?.length == ids.length) {
							let matchingUsersCount = 0;
							room.users.forEach(user => {
								if(ids.includes(user.id)) {
									matchingUsersCount++
								}
							});
							if(matchingUsersCount == room.users.length) {
								existingRoom = room;
							}
						}
					}
				}
			});
			return existingRoom;
		},
		title() {
			if(this.fields.isDirect) {
				return this.$vuetify.lang.t('$vuetify.views.chat.room.newRoom');
			}
			return this.$vuetify.lang.t('$vuetify.views.chat.room.newGroupRoom');
		},
		showInput() {
			if(this.beginChat) {
				if(this.chatExists) {
					return false;
				}
				if(this.fields.isDirect) {
					if(this.fields.users.length) {
						return true;
					}
				}
				else {
					// Not direct
					if(!this.fields.isPublic) {
						if(this.fields.users.length > 1) {
							return true;
						}
					}
					else {
						return true;
					}
				}
				return false;
			}
			return true;

		},
		attachmentsToUpload() {
			return this.fields.attachments.filter(x => !x.id);
		},
		sortedMessages() {
			if(this.chat && this.chat.messages && this.chat.messages.data) {
				return _.orderBy(this.chat.messages.data, 'id', 'asc');
			}
			return [];
		},
		dark: function () {
			return this.$vuetify.theme.dark
		},
		chatName() {
			if(this.chat.is_direct && this.chat.users) {
				return this.chat.users.find(x => x.id != this.user.id).name;
			}
			return this.getChatName();
		},
		finalMessageModel() {
			// Model to send message
			let model = {
				content: this.fields.content.content,
				mention_user_ids : this.fields.content.mentions
			};
			if(this.chat) {
				// Existing chat
				model.chat_room_id = this.chat.id;
			}
			else {
				// New chat
				if(this.fields.isDirect) {
					model.is_direct = true;
					model.user_id = this.fields.users[0].id;
				}
				else if(this.newChat){
					//
					model.chat_room_id = this.newChat.id;
				}

			}
			if(this.fields.imageTokens.length) {
				model.image_tokens = this.fields.imageTokens;
			}
			if(this.fields.attachmentTokens.length) {
				model.attachment_tokens  = this.fields.attachmentTokens;
			}
			return model;
		},
		showIntersector() {
			return true;
			/*
			if(this.chat && this.chat.messages && this.chat.messages.meta && this.chat.messages.meta.current_page < this.chat.messages.meta.last_page && !this.loadings.loading && !this.loadings.more) {
				return true;
			}
			return false;
			*/
		},
		h() {
			return this.$refs['messages-content'].scrollHeight
		},
		unreadMessages() {
			let messages = [];
			if(this.chat && this.chat.messages) {
				this.chat.messages.data.forEach(message => {
					if(message.delivery_statuses) {
						let x = message.delivery_statuses.find(d => d.recipient_user_id == this.user.id);
						if(x && !x.read_at) {
							messages.push(x)
						}
					}
				})
			}
			return messages;
		}
	},
	methods: {
		getChatName() {
			return getChatName(this.user, this.chat);
		},
		setDirect() {
			if(this.fields.isDirect) {
				this.$store.commit('chat/setTab', 'private');
				if(this.fields.users.length > 1) {
					this.fields.users = [this.fields.users[0]];
				}
			}
		},
		setTab(type) {
			this.$store.commit('chat/setTab', type);
			if(type == 'public') {
				this.fields.isPublic = true;
			}
			else {
				this.fields.isPublic = false;
			}
			this.showTab = false;
			setTimeout(() => {
				this.setActive();
			}, 1)
		},
		removeUser(user) {
			let idx = this.fields.users.findIndex(x => x.id == user.id);
			if(idx != -1) {
				this.fields.users.splice(idx, 1);
			}
		},
		trimmed(txt) {
			if(txt) {
				if(txt.length > 23) {
					return txt.substr(0, 17) + '...' +  txt.substr(txt.length - 4, 4);
				}
				return txt
			}
			return '';
		},
		async uploadAttachments() {
			let succeded = [];
			let failed = [];
			this.loadings.attachments = true;
			await Promise.all(this.attachmentsToUpload.map(async (attachment) => {
				const res = await this.uploadAttachment(attachment);
				if(res) {
					succeded.push(attachment);
				}
				else {
					failed.push(attachment);
				}
			}));
			this.loadings.attachments = false;
			if(this.attachmentsToUpload.length == succeded.length) {
				return {
					success: true
				};
			}
			return {
				success: false,
				succeded: succeded,
				failed: failed
			}
		},
		async uploadAttachment(attachment) {
			if(attachment) {
				const response = await this.$store.dispatch('files/uploadAttachment', {
					for: 'chat_attachment',
					file: attachment
				});

				if(response.success) {
					this.fields.attachmentTokens.push(response.data.token);
					return true;
				}
				else {
					return false;
				}
			}
		},
		addAttachments(files) {
			let attachments = Array.from(files);
			attachments.forEach((file) => {
				if(!this.fields.attachments.find(x => x.name == file.name)) {
					this.fields.attachments.push(file);
				}
			});
			this.setMinHeight();
		},
		deleteImage(image, message) {
			this.$refs.deleteImage.showDialog(image, message)
		},
		deleteAttachment(attachment, message) {
			this.$refs.deleteAttachment.showDialog(attachment, message)
		},
		previewImage(image) {
			this.$refs.previewImage.showDialog(image);
		},
		removeImage(index) {
			this.fields.images.splice(index, 1);
		},
		removeAttachment(index) {
			this.fields.attachments.splice(index, 1);
		},
		setImage(image) {
			this.fields.images.push({data: image});
			this.imageKey++;
			this.setMinHeight();
		},
		async messageIntersected(id, isIntersecting) {
			if(isIntersecting && this.seenMessages.findIndex(x => x == id) == -1) {
				let msg = this.getMessageData(id);
				this.seenMessages.push(id);

				if(!this.chat.is_public) {
					if(msg.user.id != this.user.id) {
						// Incoming messages
						if(!this.messageReadByMe(msg)) {
							console.log("SHOULD SET MESSAGE AS READ")
							await this.$store.dispatch('chat/setMessageRead', {
								chat_room_id: msg.chat_room_id,
								id: msg.id
							});
						}
					}
				}
				else {
					if(msg.user.id != this.user.id) {
						if(this.$moment(msg.created_at) > this.$moment(this.chat.last_presence_at)) {
							console.log("SHOULD SET ROOM READ (PUBLIC)", msg.created_at, this.chat.last_presence_at)
							this.setRoomRead()
						}
					}
				}
			}
		},
		getMessageData(id) {
			return this.sortedMessages.find(x => x.id == id);
		},
		messageReadByMe(message) {
			if(message && message.delivery_statuses) {
				let d = message.delivery_statuses.find(x => x.recipient_user_id == this.user.id);
				if(d) {
					return d.read_at;
				}
			}
			return null;
		},
		setLastMessage() {
			this.lastMessage = this.sortedMessages[this.sortedMessages.length - 1];
		},
		async onScroll({ target: { scrollTop, scrollHeight }}) {
			if(scrollTop < this.lastScrollTop) {
				if (this.intersecting) {
					if(this.chat.messages.meta.current_page < this.chat.messages.meta.last_page) {
						if (!this.loading) {
							await this.getRoom({ page: this.chat.messages.meta.current_page + 1 });
							setTimeout(() => {
								if(this.$refs['messages-content']) {
									let newScrollTop = this.$refs['messages-content'].scrollHeight - scrollHeight;
									this.$refs['messages-content'].scrollTop = newScrollTop;
								}

							}, 50);
						}
					}
				}
			}
			this.lastScrollTop = scrollTop;

		},
		setInitiated(smooth = true) {
			setTimeout(() => {
				this.scroll(smooth);
				this.initiated = true;
			}, 100);
		},
		infiniteScrolling(entries, observer, isIntersecting) {
			this.intersecting = isIntersecting;
		},
		scroll(smooth = true) {
			let element = this.$refs['end'];
			if(element) {
				element.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'end'});
			}
		},
		setMinHeight() {
			let h = this.baseHeight;
			let inputHeight = this.$refs['content-editable-input'];
			let imagesWrapperHeight = 0;
			if(inputHeight) {
				inputHeight = inputHeight.$el.clientHeight;
				if(inputHeight <= 150) {
					h = this.baseHeight - inputHeight + 5;
					imagesWrapperHeight = inputHeight + 10;
				}
				else {
					h = this.baseHeight - 150 + 5;
					imagesWrapperHeight = 160;
				}
			}
			imagesWrapperHeight = parseInt(imagesWrapperHeight);
			if(this.fields.attachments.length) {
				this.imagesWrapperStyle = "bottom: " + (imagesWrapperHeight + 28) + "px; left: 10px";
			}
			else {
				this.imagesWrapperStyle = "bottom: " + imagesWrapperHeight + "px; left: 10px";
			}

			this.attachmentsWrapperStyle = "bottom: " + imagesWrapperHeight + "px; left: 10px";
			this.contentHeight = h + 'px';
			this.showMoreStyle = 'bottom: ' + inputHeight + 'px; right: 10px';
		},
		async setRoomRead() {
			if(this.chat.unread_messages_count > 0 || this.unreadMessages.length) {
				await this.$store.dispatch('chat/setRoomReadByMe', {id: this.chat.id})
			}
		},
		async createRoom() {[]

			let payload = {
				is_direct: this.fields.isDirect,
				is_public: this.fields.isPublic
			};
			if(payload.is_public && !payload.is_direct) {
				payload.name = this.fields.name;
			}
			const res = await this.$store.dispatch('chat/createRoom', payload);

			return res;
		},
		async handleMessage() {
			let shouldSend = false;

			if(this.beginChat && !this.chat) {
				if(!this.fields.isDirect) {
					// Should create new room
					this.loadings.creatingRoom = true;
					let res = await this.createRoom();
					if(res.success) {
						let chat = res.data;
						let shouldInvite = false;
						// Invite users
						const ids = this.fields.users.map(function(user) { return user.id; });
						if(!this.fields.isPublic) {
							shouldInvite = true;
						}
						else {
							if(ids.length) {
								shouldInvite = true;
							}
						}
						if(shouldInvite) {
							const invite = await this.$store.dispatch('chat/inviteUsers', {
								chat_room_id: chat.id,
								user_ids: ids
							});
							if(invite.success) {
								shouldSend = true;
							}
							else {
								this.$snackbar.error({error: invite.error});
							}
						}
						this.newChat = chat;
						shouldSend = this.send;
					}
					else {
						this.$snackbar.error({error: res.error});
					}
					setTimeout(() => {
						this.loadings.creatingRoom = false;
					}, 300)
				}
				else if(this.fields.isDirect) {
					shouldSend = true;
				}
			}
			else {
				shouldSend = true;
			}

			if(shouldSend) {
				this.$nextTick(async () => {
					await this.sendMessage();
					this.newChat = null;
				});
			}
			else{
				await this.proceedRoom(this.newChat)
			}
		},
		async refresh() {
			return await this.$store.dispatch('chat/getRoom', {hash: this.chat.hash, refresh: true});
		},
		async proceedRoom(room) {
			console.log("PROCEED ROOM", room)
			if(!this.chat) {
					this.loadings.gettingRoom = true;
					let r = await this.$store.dispatch('chat/getRoom', {hash: room.hash, refresh: true});
					console.log("RRRR", r)
					if(r.success) {
						this.$store.commit('chat/addRoom', r.data.data);
						this.$store.commit('chat/setQuickmenu', false);

						if(this.bubble) {
							setTimeout(() => {
								this.$store.commit('chat/addBubble', {id: room.id});
								this.$store.commit('chat/expandBubble', {id: room.id});
							}, 50);
						}
						else {
							this.$router.push({name: 'Chat', params: {hash: room.hash}});
						}

						this.close();
					}
					this.loadings.gettingRoom = false;
				}
				else {
					// this.inputKey++;
					this.scroll();
				}
		},
		async sendMessage() {
			let shouldUpload = false;
			let uploadSuccess = false;
			this.loadings.sending = true;

			this.clearMessage();
			this.scroll();

			if(this.fields.images.length) {
				shouldUpload = true;
				await Promise.all(this.fields.images.map(async (image) => {
					const s = await this.uploadImage(image);
					if(s) {
						uploadSuccess = true;
					}
				}));
			}
			if(this.fields.attachments.length) {
				shouldUpload = true;
				const res = await this.uploadAttachments();
				if(res.success) {
					uploadSuccess = true;
				}
				else {
					uploadSuccess = false
					console.log("FAILED UPLOADING ATTACHMENTS", res);
				}
			}

			if(!shouldUpload || (shouldUpload && uploadSuccess)) {
				// What type of chat is it?
				let res = await this.$store.dispatch('chat/sendMessage', this.finalMessageModel);
				this.fields.content = {};
				setTimeout(() => {
					this.fields.imageTokens = [];
					this.fields.images = [];
					this.fields.attachmentTokens = [];
					this.fields.attachments = [];
				}, 100)

				console.log("RES MESSAGE", res)


				if(res.success) {
					await this.proceedRoom({
						id: res.data.chat_room_id,
						hash: res.data.chat_room_hash
					});
				}
			}
			this.currentWhisperTimeout = 0;
			this.loadings.sending = false;
		},
		setUser(user) {
			if(this.fields.users.findIndex(x => x.id == user.id) == -1) {
				this.fields.users.push(user);
			}
			if(this.fields.isDirect) {
				let room = this.searchRoomsForUser(user);
				this.goToChat(room);
			}
			this.existsKey++;
		},
		goToChat(room) {
			if(room) {
				if(this.bubble) {
					this.$store.commit('chat/setQuickmenu', false);
					this.$store.commit('chat/addBubble', room);
					this.$store.commit('chat/expandBubble', room);
				}
				else {
					this.$router.push({name: 'Chat', params: {hash: room.hash}})
				}
				this.close();
			}
		},
		clearMessage() {
			if(this.$refs['content-editable-input']) {
				this.$refs['content-editable-input'].clear();
			}
		},
		searchRoomsForUser(user) {
			// Private room
			let room = null;
			this.rooms.forEach(r => {
				if(r.users.findIndex(x => x.id == user.id) != -1) {
					room = r;
				}
			});
			return room;
		},
		close() {
			this.$emit('close');
			this.$store.commit('chat/closeNewMessagePopup');
		},
		onInput(e) {
			if(e?.content) {
				this.whisper();
			}
			this.setMinHeight();
		},
		whisper() {
			let counter = 0;

			if(this.clock <= this.whisperTimeout) {
				counter = this.clock;
			}
			else {
				counter = this.whisperTimeout;
			}
			if(this.clock - this.currentWhisperTimeout >= counter) {
				this.currentWhisperTimeout = this.clock;
				this.$echo.private("company." + this.user.company_id).whisper('typing', {
					where: 'chat',
					chat_room_id: this.chat?.id,
					chat_room_hash: this.chat?.hash,
					user_id: this.user.id,
					user_clock: this.clock,
					user: {
						id: this.user.id,
						name: this.user.name
					}
				});
			}
		},

		addMessage() {
			//
		},
		minimizePopup() {
			setTimeout(() => {
				this.$store.commit('chat/minimizeBubble', this.chat)
			}, 100)
		},
		onClickOutside() {
			this.active = false;
			if(this.chat) {
				this.$store.commit('chat/setBubbleInactive', this.chat);
			}
		},
		setActive() {
			if(this.bubble) {
				if(!this.active) {
					this.active = true;
					if(this.chat) {
						this.$store.commit('chat/setBubbleActive', this.chat);
					}
				}
			}
		},
		async getRoom(p) {
			let params = Object.assign({}, p);
			params.hash = this.chat.hash;

			if(params && params.page && params.page > 1) {
				this.loadings.more = true;
			}
			else {
				this.loadings.loading = true;
			}
			await this.$store.dispatch("chat/getRoom", params);
			this.loadings.more = false;
			this.loadings.loading = false;
		},
		async uploadImage(image) {
			if(image) {
				this.loadings.images = true;
				const response = await this.$store.dispatch('files/uploadPhoto', {
					for: 'chat_image',
					file: encodeURIComponent(image.data)
				});
				if(response.success) {
					this.fields.imageTokens.push(response.data.token);
					this.loadings.images = false;
					return true;
				}
				else {
					this.loadings.images = false;
					return false;
				}
			}
		},
		setBaseWidth() {
			if(this.$refs.wid) {
				let width = this.$refs.wid.clientWidth;
				this.baseWidth = width + 'px';
			}

		}
	},
	async created() {
		this.contentHeight = this.baseHeight;
		this.onScroll = _.debounce(this.onScroll, 200);
		setTimeout(() => {
			this.setMinHeight();
			this.setBaseWidth();
		}, 200);
		if(this.chat) {
			if(this.chat.is_public) {
				this.$store.commit('chat/setTab', 'public');
			}
			else {
				this.$store.commit('chat/setTab','private');
			}
			if(!this.chat.messages) {
				await this.getRoom();
				this.setLastMessage();
				this.setMinHeight();
			}
			this.setRoomRead();
		}
		else {
			if(this.tab == 'public') {
				this.fields.isDirect = false;
				this.fields.isPublic = true;
				this.send = false;
			}
			else {
				this.fields.isPublic = false;
				this.send = true;
			}
		}
		this.setInitiated(false);
	},
}
</script>

<style lang="scss">
	.whispering {
		font-size: 12px;
		position: absolute;
		bottom: 40px;
		padding: 3px 0px;
		// background: white;
		width: calc(100% - 24px);
		left: 12px;
		background: white;
	}
	.jumping-dots {
		.dot {
			width: 4px;
			height: 4px;
			background: var(--v-accent-base);
			display: inline-block;
			border-radius: 50%;
			right: 0px;
			bottom: 0px;
			margin: 0px 1px;
			position: relative;
			animation: jump 1s infinite;
		}
			.dots-cont:hover > .dot {
			/* position: relative; */
			/* bottom: 0px; */
			animation: none;
		}
			.dots-cont .dot-1 {
			-webkit-animation-delay: 100ms;
			animation-delay: 100ms;
		}
			.dots-cont .dot-2 {
			-webkit-animation-delay: 200ms;
			animation-delay: 200ms;
		}
			.dots-cont .dot-3 {
			-webkit-animation-delay: 300ms;
			animation-delay: 300ms;
		}
		@keyframes jump {
			0%   {bottom: 0px;}
			20%  {bottom: 5px;}
			40%  {bottom: 0px;}
		}
	}

	.chat-users-tip {
		padding: 4px 8px;
		background: var(--v-grey-lighten1);
		border-radius: 4px;
		margin-top: 8px;
		display: flex;
		align-items: center;
		font-size: 12px;
	}
	.disabled {
		pointer-events: none;
	}
	.chat-images-wrapper {

		.remove {
			position: absolute;
			right: 5px;
			top: -5px;
			z-index: 2;
			background: white;
		}
	}
	.content-wrapper {
		position: absolute;
		bottom: 0;
		width: 100%;
		background: white;
		max-height: 150px;
		overflow-y: auto;
	}
	.chat-popup {
		.v-card__title {
			padding-top: 12px;
			padding-bottom: 12px
		}
		.chat-popup-activator {
			> .v-card__text {

				.chat-messages-content {
					padding: 12px;
					overflow-y: auto;
				}
			}
		}


		&.bubble-active {
			.v-card__title {
				background: var(--v-primary-base);
				color: white;
			}
		}
	}

</style>
}
